// extracted by mini-css-extract-plugin
export default {"zoomControls":"Tua-z","zoomControlButton":"Uua-z","zoomBanner":"Vua-z","bannerButton":"Wua-z","imageButton":"Xua-z","zoom":"Yua-z","zoomContent":"Zua-z"};